import { ReactElement } from 'react';

import {
  IconButton,
  Icons,
  SxProps,
  HexIcon,
  HexIconElementProps,
  Typography,
  Box,
  Stack,
  tokens,
  mergeSx,
} from '@cast/design-system';

export const HpaSettingsBanner = ({
  sx,
  hexIcon,
  title,
  description,
  actionButtons,
  orientation = 'vertical',
  testId = 'hpa-settings-banner',
  onClose,
}: {
  sx?: SxProps;
  hexIcon?: {
    Icon: ReactElement<HexIconElementProps>;
    size: number;
    iconColor: string;
    hexColor: string;
  };
  title?: string;
  description?: string | ReactElement;
  actionButtons?: ReactElement;
  orientation?: 'horizontal' | 'vertical';
  testId?: string;
  onClose?: () => void;
}) => {
  return (
    <Box
      data-testid={testId}
      sx={mergeSx(
        {
          bgcolor: tokens.theme.bg.structural.surface,
          color: tokens.theme.fg.structural.primary,
          border: `1px solid ${tokens.theme.border.structural.neutral}`,
          borderRadius: 1,
          p: 16,
          pb: orientation === 'horizontal' ? 16 : 32,
          boxShadow: tokens.theme.shadows.elevation.medium,
        },
        sx
      )}
    >
      <Stack
        direction={orientation === 'horizontal' ? 'row' : 'column'}
        gap={12}
        alignItems="center"
        position="relative"
      >
        {hexIcon && (
          <HexIcon
            size={hexIcon.size}
            icon={hexIcon.Icon}
            iconColor={hexIcon.iconColor}
            hexColor={hexIcon.hexColor}
          />
        )}

        {onClose && (
          <Box position="absolute" top={-6} right={-6} height={16} width={16}>
            <IconButton onClick={onClose}>
              <Icons.X
                className="DsAlert-close"
                size="small"
                onClick={onClose}
                opacity={0.5}
              />
            </IconButton>
          </Box>
        )}
        <Stack
          gap={4}
          flex={1}
          alignItems={orientation === 'horizontal' ? 'flex-start' : 'center'}
        >
          {title && (
            <Typography variant="h6" color={tokens.theme.fg.structural.primary}>
              {title}
            </Typography>
          )}

          {description && (
            <Typography
              variant="P12R"
              color={tokens.theme.fg.structural.secondary}
            >
              {description}
            </Typography>
          )}
        </Stack>

        {actionButtons && (
          <Box mt={orientation === 'horizontal' ? 0 : 16}>{actionButtons}</Box>
        )}
      </Stack>
    </Box>
  );
};
